module.exports = __webpack_public_path__ + "92b1fc977ef0a733bd367473c010c1b8.png";